export const ADMIN_LOCALES = [
  { code: "en", label: "English", tone: "primary" },
  { code: "pt-BR", label: "Portuguese", tone: "success" },
  { code: "de", label: "German", tone: "warning" },
  { code: "es", label: "Spanish", tone: "danger" },
];

export const CONTENT_GROUPS = [
  {
    key: "navigation",
    title: "Navigation",
    description: "Header labels used by the public website.",
    fields: [
      ["menu_about", "About"],
      ["menu_news", "News"],
      ["menu_tour", "Tour"],
      ["menu_albums", "Albums"],
      ["menu_media", "Media"],
      ["menu_follow", "Follow"],
    ],
  },
  {
    key: "hero",
    title: "Hero",
    description: "First-fold quote and main emotional message.",
    fields: [["hero_quote", "Main quote", "textarea"]],
  },
  {
    key: "tour",
    title: "Tour Dates",
    description: "Section heading for upcoming shows.",
    fields: [
      ["tour_title", "Title"],
      ["tour_subtitle", "Subtitle"],
    ],
  },
  {
    key: "about",
    title: "About",
    description: "Band biography and supporting copy.",
    fields: [
      ["about_title", "Title"],
      ["about_subtitle", "Subtitle"],
      ["about_description", "Intro description", "textarea"],
      ["about_paragraphs", "Biography paragraphs", "textarea"],
    ],
  },
  {
    key: "media",
    title: "Media",
    description: "Copy displayed above the media carousel.",
    fields: [
      ["media_title", "Title"],
      ["media_description", "Description", "textarea"],
    ],
  },
  {
    key: "albums",
    title: "Albums",
    description: "Copy displayed above the discography grid.",
    fields: [
      ["albums_title", "Title"],
      ["albums_description", "Description", "textarea"],
    ],
  },
  {
    key: "follow",
    title: "Follow",
    description: "Social section labels and call to action.",
    fields: [
      ["follow_title", "Title"],
      ["follow_description", "Description", "textarea"],
      ["follow_posts", "Posts label"],
      ["follow_followers", "Followers label"],
      ["follow_button", "Button label"],
    ],
  },
  {
    key: "news",
    title: "News",
    description: "Section heading for WordPress posts.",
    fields: [
      ["news_title", "Title"],
      ["news_description", "Description", "textarea"],
      ["news_category", "Category label"],
      ["common_view_more", "View more label"],
    ],
  },
  {
    key: "footer",
    title: "Footer",
    description: "Legal copy and production credit.",
    fields: [
      ["footer_copy", "Copyright text", "textarea"],
      ["footer_powered_by", "Powered by label"],
    ],
  },
];
